import React, { ComponentType, ReactElement } from 'react';
import { isSome } from 'fp-ts/Option';
import { Loading, Result, Button, ResultVariants } from '@dexma/ui-components';
import i18n from 'asset/translation';
import { DefaultUseCaseState, UseCaseState } from 'adapter/in/common/hooks/useCase';

export type ViewState<T> = UseCaseState & { data: T } & { errorAction?: () => void };

const withLoading = <T, R>(Component: ComponentType<ViewState<T> & R>) => (
    props: DefaultUseCaseState<T> & { errorAction?: () => void } & Omit<R, 'data'>
): ReactElement => {
    const { data, isLoading, error, errorAction } = props;
    let result = <Loading isLoading size={50} />;
    // eslint-disable-next-line react/jsx-props-no-spreading
    if (data && isSome(data)) result = <Component {...{ ...(props as DefaultUseCaseState<T> & R), data: data.value }} />;
    if (isLoading) result = <Loading isLoading size={50} />;
    if (error && isSome(error)) {
        result = (
            <Result
                content={
                    errorAction && (
                        <>
                            <Button variant='secondary' text={i18n.t('common.tryAgainAction')} onClick={errorAction} />
                        </>
                    )
                }
                variant={ResultVariants.ERROR}
                title={i18n.t('common.errorWrong')}
                info={i18n.t('common.errorWrongInfo')}
                icon='bot-dead'
            />
        );
    }

    return result;
};

export default withLoading;
